import { Component, createRef } from "react";
import parse from 'html-react-parser';

class Answer extends Component {

    constructor(props) {
		super(props);
		this.state = {
			opened: false,
            firstCardHeight: 0,
		};
        this.container = createRef();
		this.toggleBox = this.toggleBox.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
	}

    state = {}

    componentDidMount() {
        if (this.container.current){
            let value = this.container.current.offsetHeight;
            this.setState({ firstCardHeight: value })
        }
        // EventListener für Klicks
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        // EventListener aufräumen
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (
            this.state.opened &&
            this.container.current &&
            !this.container.current.contains(event.target)
        ) {
            this.setState({ opened: false });
        }
    }

    toggleBox() {
		const { opened } = this.state;
		this.setState({
			opened: !opened
		});

        setTimeout(() => {
            this.setState({ height: this.container.current.offsetHeight });
            this.props.updateRowHeight(this.container.current.offsetHeight,this.props.index,this.state.firstCardHeight);
        }, 500);
	}

    customSubstring(str, length) {
        if (str.length <= length) {
            return str;
        }
    
        // Suche nach dem letzten Leerzeichen vor oder bei der gegebenen Länge
        let lastSpaceIndex = str.lastIndexOf(' ', length);
    
        // Wenn kein Leerzeichen gefunden wurde, schneide direkt ab
        if (lastSpaceIndex === -1) {
            return str.substring(0, length);
        }
    
        // Andernfalls schneide bis zum letzten Leerzeichen ab
        return str.substring(0, lastSpaceIndex);
    }

    render(){

        var { title } = this.props;
        const { opened } = this.state;

		if (opened){
			title ='opened';
		}else{
			title ='closed';
		}

        return (
            <>
                {this.props.hidden === 0 ? (
                    <>
                        <div className="col-md-4">
                            <div className={'card ' + title} ref={this.container}>
                                <div onClick={this.props.onAdd} className="card-img">
                                    <img src={this.props.image} className="card-img-top" alt="..." />
                                </div>
                                <div onClick={this.props.onAdd} className="card-body">
                                    <div className='card-text'>
                                        <h4 className="title">{this.props.title}</h4>
                                        {this.props.description && this.state.opened
                                            ? (
                                                <div className="description">
                                                    {parse(`${this.props.description}`)}
                                                </div>
                                            ): ''
                                        }
                                    </div>
                                </div>
                                {this.props.description
                                    ? <button className="showMore" onClick={this.toggleBox} />
                                    : ''
                                }
                            </div>
                        </div>
                        {this.state.opened
                            ? <div className="bg_overlay"></div>
                            : ''
                        }
                    </>
                ) : ''
                }
            </>
        );
    }
}

export default Answer;